// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.create-server-modal {
  width: 100%;
  max-width: 440px;
  background: #0f172a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.modal-header {
  padding: 24px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  color: #ef4444;
}

.modal-header h2 {
  font-size: 18px;
  font-weight: 800;
  color: #f8fafc;
}

.close-btn {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #f8fafc;
}

.modal-body {
  padding: 32px;
}

.modal-description {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 32px;
}

.input-group label {
  display: block;
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 10px;
}

.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
}

.input-wrapper input {
  width: 100%;
  background: #020617;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 14px 14px 14px 48px;
  color: #f8fafc;
  font-size: 15px;
  outline: none;
  transition: all 0.2s;
}

.input-wrapper input:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

.modal-footer {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.cancel-btn {
  background: none;
  border: none;
  color: #f8fafc;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  padding: 12px 20px;
}

.submit-btn {
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 28px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn:hover:not(:disabled) {
  background: #dc2626;
  transform: translateY(-1px);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateServerModal/CreateServerModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.create-server-modal {\n  width: 100%;\n  max-width: 440px;\n  background: #0f172a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.modal-header {\n  padding: 24px 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.header-icon {\n  color: #ef4444;\n}\n\n.modal-header h2 {\n  font-size: 18px;\n  font-weight: 800;\n  color: #f8fafc;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.close-btn:hover {\n  color: #f8fafc;\n}\n\n.modal-body {\n  padding: 32px;\n}\n\n.modal-description {\n  color: #94a3b8;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 32px;\n}\n\n.input-group label {\n  display: block;\n  font-size: 11px;\n  font-weight: 800;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 10px;\n}\n\n.input-wrapper {\n  position: relative;\n}\n\n.input-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n}\n\n.input-wrapper input {\n  width: 100%;\n  background: #020617;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 14px;\n  padding: 14px 14px 14px 48px;\n  color: #f8fafc;\n  font-size: 15px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.input-wrapper input:focus {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);\n}\n\n.modal-footer {\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n\n.cancel-btn {\n  background: none;\n  border: none;\n  color: #f8fafc;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 12px 20px;\n}\n\n.submit-btn {\n  background: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 28px;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n\n.submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
